import { createContext, useContext, useState } from "react";

const TabNavContext = createContext({ requestedTab: null, requestTab: () => {}, clearTab: () => {} });

export function TabNavProvider({ children }) {
  const [requestedTab, setRequestedTab] = useState(null);
  const requestTab = (tab) => setRequestedTab(tab);
  const clearTab = () => setRequestedTab(null);
  return (
    <TabNavContext.Provider value={{ requestedTab, requestTab, clearTab }}>
      {children}
    </TabNavContext.Provider>
  );
}

export const useTabNav = () => useContext(TabNavContext);
